var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneAtivo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#374899"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5569 10.5988C12.299 10.0263 12.028 10.0132 11.7834 10.0066C11.585 10 11.3536 10 11.1222 10C10.8908 10 10.5206 10.0855 10.2033 10.4277C9.88591 10.7698 9 11.5989 9 13.2899C9 14.9744 10.2363 16.6062 10.4082 16.8365C10.5801 17.0668 12.7949 20.6397 16.2923 22.0149C19.2012 23.1598 19.7962 22.9295 20.4243 22.8702C21.0524 22.811 22.4606 22.0412 22.7515 21.2384C23.0358 20.4357 23.0358 19.7514 22.9498 19.6066C22.8639 19.4619 22.6325 19.3763 22.2887 19.2052C21.9449 19.0342 20.2524 18.2051 19.9351 18.0867C19.6177 17.9748 19.3863 17.9156 19.1616 18.2577C18.9302 18.5999 18.269 19.3697 18.0707 19.6C17.8724 19.8303 17.6674 19.8567 17.3236 19.6856C16.9798 19.5145 15.8691 19.1526 14.5535 17.9814C13.5287 17.0734 12.8346 15.9482 12.6362 15.6061C12.4379 15.2639 12.6164 15.0797 12.7883 14.9086C12.9403 14.7573 13.1321 14.5072 13.304 14.3098C13.4758 14.1124 13.5353 13.9677 13.6477 13.7374C13.7601 13.5071 13.7072 13.3097 13.6213 13.1386C13.5353 12.9741 12.861 11.2765 12.5569 10.5988Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneAtivo);
export default __webpack_public_path__ + "static/media/Phone-Ativo.4adadc41.svg";
export { ForwardRef as ReactComponent };